export const ERROR_REQUIRED = 'This field is required';
export const ERROR_EMAIL = 'Incorrect email';

export const initialClaimForm = {
  id: '',
  airlineAmicableAnswer: '',
  airlinePreLitigationAnswer: '',
  overallDelayAtDestination: '',
  lawyerFormalNoticeDate: '',
  passengerTicket: {
    compensationTransfer: '',
    passengerFirstName: '',
    passengerLastName: '',
    passengerEmail: '',
    passengerCountry: '',
    desc: '',
    pnr: '',
    number: '',
    employer: '',
    passengerLanguage: '',
    affiliate: '',
  },
  flights: [
    {
      id: '',
      number: '',
      airline: '',
      airportOrigin: '',
      airportDestination: '',
      localArrivalDate: undefined,
      localDepartureDate: undefined,
      arrivalTime: '00:00',
      departureTime: '00:00',
    },
  ],
  secretToken: '',
  comments: '',
  lawyer: '',
  litigationCountry: '',
  nebSentDate: undefined,
  courtName: '',
  courtAddress: '',
  conciliationAt: undefined,
  nRg: '',
  courtHearingAt: undefined,
  courtDecisionDate: undefined,
  airlineAgreementAmount: '',
  airlineAgreementDate: undefined,
  settlementType: '',
  legalFees: '',
  refundFromLawyerDate: undefined,
  refundFromLawyerAmountForPax: '',
  refundFromLawyerLegalFeesAmount: '',
  paxTransferDate: undefined,
  paxToTransferAmount: '',
};



// WEBPACK FOOTER //
// ./src/component/ClaimForm/constants.js